<template>
	<div class="log-software-component">
		<div class="title-block__media-md">
			<div class="tabs">
				<div class="tabs__log-ctrls">
                        <div class="title-block__title">Логи</div>
                    <button @click="setSelectedTab($event.target.id)"
                            :class="{'selected': tab.logUpdatesInstall}"
                            id="logUpdatesInstall"
                            class="reset-btn tabs__log-ctrl">
                        Установка обновлений
                    </button>
                    <button @click="setSelectedTab($event.target.id)"
                            :class="{'selected': tab.logUpdatesDownload}"
                            id="logUpdatesDownload"
                            class="reset-btn tabs__log-ctrl">
                        Загрузка обновлений
                    </button>
                    <button @click="setSelectedTab($event.target.id)"
                            :class="{'selected': tab.logUpdateContent}"
                            id="logUpdateContent"
                            class="reset-btn tabs__log-ctrl">
                            Обновления контента
					</button>
                    <button @click="setSelectedTab($event.target.id)"
                            :class="{'selected': tab.logUpdateLog}"
                            id="logUpdateLog"
                            class="reset-btn tabs__log-ctrl">
                        Журнал
                    </button>
                    <button @click="setSelectedTab($event.target.id)"
                            :class="{'selected': tab.logUpdateHardware}"
                            id="logUpdateHardware"
                            class="reset-btn tabs__log-ctrl">
                        Оборудование
                    </button>
				</div>
			</div>
		</div>
	</div>

    <log-install-updates-component
        v-if="tab.logUpdatesInstall"
        :route_list="route_installations_logs_list"
        :route_brands_list="route_brands_list"
        :route_device_type_options="route_device_type_options"
        :route_version_options="route_version_options"
        :route_clients="route_clients"
        :route_export="route_installations_logs_export"
    />
    <log-downloads-updates-component
        v-else-if="tab.logUpdatesDownload"
        :route_list="route_download_logs_list"
        :route_brands_list="route_brands_list"
        :route_device_type_options="route_device_type_options"
        :route_version_options="route_version_options"
        :route_clients="route_clients"
        :route_export="route_downloads_logs_export"
    />
	<log-content-update-component v-else-if="tab.logUpdateContent" />
	<log-events-component v-else-if="tab.logUpdateLog" />
    <log-hardware-component v-else-if="tab.logUpdateHardware" />

</template>

<script>
import { mapState, mapMutations } from 'vuex/dist/vuex.cjs.js';

export default {
    name: 'LogComponent',
    props: {
        route_installations_logs_list: String,
        route_version_options: String,
        route_download_logs_list: String,
        route_installations_logs_export: String,
        route_downloads_logs_export: String,
        route_device_type_options: String,


        route_list_log_installations: String,
        route_list_log_downloads: String,
        route_brands_list: String,
        route_versions: String,
        route_clients: String,
    },

	data() {
		return {

		}
	},

	computed: {
		...mapState('logs', ['tab'])
	},

	methods: {
		...mapMutations('logs', ['setSelectedTab']),
	}
}
</script>

<style scoped lang="scss">
	.title-block {
		display: flex;
		flex-direction: row;
		justify-content: flex-start;
	}
	.page-label {
		font-size: 18px;
		font-weight: 600;
	}
    .title-block__title {
        margin-bottom: 6px;
    }
    .tabs {
        margin-bottom: 20px;
    }
</style>
